import { redirect } from '@tanstack/react-router'
import { resolveLoginAppUrl } from '@imobdesk/env'
import { getAccessToken } from '@/lib/token-storage'
import { getImobdeskEnvRecord } from '@/lib/imobdesk-env-record'

/**
 * URL base do app dedicado de login (Vite). Ex.: https://login.imobdesk.com.br ou http://localhost:3010
 */
export function getLoginAppOrigin(): string {
  return resolveLoginAppUrl(getImobdeskEnvRecord())
}

/** Redireciona para o app de login ou para página de configuração (evita loop com `/`). */
export function redirectToLoginApp() {
  const origin = getLoginAppOrigin()
  if (origin) {
    /** Mesma chave de token no login — força limpeza no host do login após logout aqui. */
    return redirect({ href: `${origin}/?signed_out=1` })
  }
  return redirect({ to: '/configuracao-login' })
}

/** Navegação total (ex.: após logout) para o app de login. */
export function goToLoginApp(options?: {
  sessionEnded?: 'superseded'
}): void {
  const origin = getLoginAppOrigin()
  if (origin) {
    const url = new URL(origin)
    url.pathname = '/'
    if (options?.sessionEnded === 'superseded') {
      url.searchParams.set('session_ended', 'superseded')
    } else {
      url.searchParams.set('signed_out', '1')
    }
    window.location.href = url.toString()
    return
  }
  window.location.href = '/configuracao-login'
}

/**
 * Abre o app de login já com a sessão do app principal (tokens na query),
 * para rotas autenticadas no login como `/conta`.
 */
export function goToLoginAppConta(): void {
  const origin = getLoginAppOrigin()
  const access = getAccessToken()
  if (!origin) {
    goToLoginApp()
    return
  }

  const isSecureProdDomain = origin.includes('.imobdesk.com.br')
  if (isSecureProdDomain) {
    window.location.href = `${origin}/conta`
    return
  }

  if (!access) {
    goToLoginApp()
    return
  }
  const url = new URL(`${origin}/auth/import-session`)
  url.searchParams.set('access_token', access)
  url.searchParams.set('then', '/conta')
  window.location.href = url.toString()
}
